import { Component } from "react";

export class LoginErrorBoundary extends Component {
  // v5.6.4 · si el error es transitorio (p. ej. el traductor del navegador cambió el DOM mientras React
  // actualizaba el botón), se vuelve a montar el formulario solo, sin mostrar la pantalla de error.
  state = { hasError: false, attempt: 0 };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("LoginErrorBoundary caught:", error, info);
    if (this.state.attempt < 2) {
      setTimeout(() => this.setState((s) => ({ hasError: false, attempt: s.attempt + 1 })), 0);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="jasq-card p-7 text-center space-y-4" data-testid="login-error-boundary">
          <p className="text-sm font-bold text-[#1F2547]">
            Ocurrió un error inesperado en el formulario de inicio de sesión.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="px-5 py-2.5 rounded-xl bg-[#A43790] text-white font-bold text-sm hover:bg-[#7B2A6C] transition-colors"
            data-testid="login-error-reload"
          >
            Recargar página
          </button>
        </div>
      );
    }
    return <div key={this.state.attempt} style={{ display: "contents" }}>{this.props.children}</div>;
  }
}
